/**
 * Accordion: toggle accordion panels
 */
(function($) {
  "use strict";

  $(window).ready(init);

  // Constants
  var CONTAINER_SEL = "[data-accordion]";
  var CONTROL_SEL = "[aria-controls]";
  var DETAIL_SEL = '[aria-hidden]';

  /**
   * Init
   */
  function init() {
    var container = $(CONTAINER_SEL);
    if (container.length === 0) {
      return;
    }

    container.find('[aria-hidden="true"]').hide();

    container.on("click", CONTROL_SEL, function() {
      var header = $(this);
      var panel = $("#" + header.attr("aria-controls"));
      header.attr(
        "aria-expanded",
        header.attr("aria-expanded") == "true" ? "false" : "true"
      );
      panel
        .attr(
          "aria-hidden",
          panel.attr("aria-hidden") == "true" ? "false" : "true"
        )
        .slideToggle();
      header.parent().siblings().find(CONTROL_SEL).attr('aria-expanded', 'false');
      header.parent().siblings().find(DETAIL_SEL).attr('aria-hidden', 'true').slideUp();
    });
  }
})(jQuery);
